import { styled } from '@mui/material/styles';

import { rem, Theme } from '../..';
import { AlertMessage } from '../AlertMessage';
import { ButtonBase } from '../Button';
import { ButtonLink } from '../ButtonLink';
import { SearchInput } from '../Forms';
import { Heading } from '../Heading';
import { Icon } from '../Icon';
import { Paragraph } from '../Paragraph';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;
        padding: ${theme.tggSpacing(rem(3), 7.5)};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        text-align: center;
        background-color: ${theme.palette.grey[900]};
        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(128), 320)};
            padding: ${theme.tggSpacing([rem(3), 0], [7.5, 0])};
        }
	`}
`;

export const StyledIcon = styled(Icon)`
    ${({ theme }: { theme: Theme }) => `
        && {
            margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};
        }
	`}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_25_bold_desktop_31};
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        color: ${theme.palette.common.blue};
	`}
`;

export const StyledSearchParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.common.blue};
	`}
`;

export const StyledResultsParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXSmall};
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(1.5), 3.75)};
        text-align: left;
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledAlertMessage = styled(AlertMessage)`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(2), 5)};
        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(70.8), 283)};
            margin: ${theme.tggSpacing([0, 'auto', rem(2)], [0, 'auto', 5])};
        }
	`}
`;

export const StyledSearchInput = styled(SearchInput)`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;
        margin: ${theme.tggSpacing([0, 'auto', rem(2)], [0, 'auto', 5])};
        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(70.8), 283)};
        }
	`}
`;

export const StyledButtonLink = styled(ButtonLink)`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        gap: ${theme.tggSpacing(rem(0.5), 1.25)};
        align-items: flex-end;
        justify-content: center;
        width: 100%;
	`}
`;

export const StyledButtonBase = styled(ButtonBase)`
    ${({ theme }: { theme: Theme }) => `
        width: 100%;
        max-width: ${theme.tggSpacing(rem(33.5), 83.75)};
        margin-top: ${theme.tggSpacing(rem(2), 5)};
	`}
`;
